import { Spinner } from './Spinner';

/**
 * Loader de démarrage : logo CIME qui apparaît en slide-in-from-bottom + fade-in,
 * avec un petit spinner en dessous. Affiché pendant l'init de session et le fetch
 * d'identité, pour éviter le flash "Compte non configuré".
 */
export function BrandedLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-cime-bg">
      <img
        src="/cime-logo-loader.svg"
        alt="CIME Avocats"
        className="h-16 w-auto cime-logo-rise"
      />
      <Spinner size="sm" />
    </div>
  );
}
